import { Users } from "lucide-react";

function EmptyAdminUsers() {
    return (
        <div className="empty-state">
            <Users size={60} />

            <h3>No Admin Users Found</h3>

            <p>No admin users are available.</p>
        </div>
    );
}

export default EmptyAdminUsers;